export default "__VITE_ASSET__B9bd9jx8__"